<section
  id="contact-us"
  *ngIf="data"
  class="contactussection teaser option_03"
  data-dte-section="contact-us"
  [ngClass]="contactFormToggle ? 'formvisible' : 'formhidden'"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</section>

<ng-template #content>
  <div class="container">
    <div
      *ngIf="data.image"
      class="contactussectioncontent"
      [class.threecolumn]="data.image.imageUrl"
      [class.onlyoneitem]="data.image.imageUrl && data.itemList.length === 1"
      [class.tworows]="data.image.imageUrl && data.itemList.length > 2"
    >
      <header class="contactusheader" *ngIf="data.headline">
        <h1 [innerHTML]="data.headline | superscripe"></h1>
      </header>
      <div class="column leftcolumn">
        <figure *ngIf="data.image.imageUrl">
          <da-progressive-image
            [options]="{
                            alt: data.image.altText || data.headline,
                            aspectRatios: [
                                {
                                    breakpoint: 360,
                                    width: 480,
                                    height: 270,
                                    akamaiImage: data.image.imageUrl
                                },
                                {
                                    breakpoint: 480,
                                    width: 380,
                                    height: 214,
                                    akamaiImage: data.image.imageUrl
                                },
                                {
                                    breakpoint: 768,
                                    width: 480,
                                    height: 270,
                                    akamaiImage: data.image.imageUrl
                                }
                            ]
                        }"
          ></da-progressive-image>
        </figure>
        <ng-container *ngIf="!data.image.imageUrl && data.itemList && data.itemList[0]">
          <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[0] }"></ng-container>
        </ng-container>
      </div>
      <div class="column centercolumn">
        <ng-container *ngIf="!data.image.imageUrl && data.itemList && data.itemList[1]">
          <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[1] }"></ng-container>
        </ng-container>
        <ng-container *ngIf="data.image && data.image.imageUrl && data.itemList && data.itemList[0]">
          <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[0] }"></ng-container>
        </ng-container>
      </div>
      <div class="column rightcolumn" *ngIf="data.image && data.image.imageUrl && data.itemList.length > 1">
        <ng-container *ngIf="!data.image.imageUrl && data.itemList && data.itemList[2]">
          <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[2] }"></ng-container>
        </ng-container>
        <ng-container *ngIf="data.image && data.image.imageUrl && data.itemList && data.itemList[1]">
          <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[1] }"></ng-container>
        </ng-container>
      </div>
      <div
        class="column secondcentercolumn"
        *ngIf="data.image && data.image.imageUrl && data.itemList.length > 2 && data.itemList[2]"
      >
        <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[2] }"></ng-container>
      </div>
      <div
        class="column secondrightcolumn"
        *ngIf="data.image && data.image.imageUrl && data.itemList.length > 3 && data.itemList[3]"
      >
        <ng-container *ngTemplateOutlet="contactDataItem; context: { contactData: data.itemList[3] }"></ng-container>
      </div>
      <footer class="contactusfooter" *ngIf="data.hubspotFormBoxData && showHubSpotForm">
        <da-show-more
          #showMore
          [backgroundColor]="'draegerblue'"
          [buttonLabelMore]="translations['buttonLabelMore']"
          [labelMore]="translations['labelMore']"
          [labelLess]="translations['labelLess']"
          (toggle)="toggleContactForm()"
        ></da-show-more>
      </footer>
    </div>
  </div>
</ng-template>

<div id="contactform" [className]="contactFormToggle ? 'visible' : 'hidden'">
  <div class="container">
    <da-hubspot-form-box [data]="hubspotFormBoxData$ | async"></da-hubspot-form-box>
  </div>
</div>

<ng-template let-contactData="contactData" #contactDataItem>
  <ng-container *ngIf="contactData">
    <h4 *ngIf="contactData.headline" [innerHTML]="contactData.headline | superscripe"></h4>
    <div *ngIf="contactData.text01 && contactData.text01.value"
         [innerHTML]="contactData.text01.value | superscripe"></div>
    <ng-container *ngIf="contactData.phoneNumber">
      <a [link]="'tel:' + contactData.phoneNumber" da-link icon="drg-icon-phone">{{ contactData.phoneNumber }}</a>
    </ng-container>
    <ng-container *ngIf="contactData.email">
      <div><a [link]="'mailto:' + contactData.email" da-link icon="drg-icon-sent">{{ contactData.email }}</a></div>
    </ng-container>
    <div *ngIf="contactData.text02 &&contactData.text02.value"
         [innerHTML]="contactData.text02.value | superscripe"></div>
  </ng-container>
</ng-template>
